// src/firebase/firebaseConfig.js

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCv_9O2ZhC9jW2C9L-2vNhOjoMbTQdGi5Y",
  authDomain: "student-fee-admission-system.firebaseapp.com",
  databaseURL: "https://student-fee-admission-system-default-rtdb.firebaseio.com",
  projectId: "student-fee-admission-system",
  storageBucket: "student-fee-admission-system.firebasestorage.app",
  messagingSenderId: "1009657295375",
  appId: "1:1009657295375:web:acb4a126051f57cd52e97a",
  measurementId: "G-NHF1SQ7X95"
};

// Initialize Firebase

export default firebaseConfig;  // Export the config to use in other files
